<template>
  <div class="d-flex flex-column flex-root print-content-only" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div id="kt_content" class="content d-flex flex-column flex-column-fluid">
          <KTSubheader v-if="subheaderDisplay" v-bind:breadcrumbs="breadcrumbs" v-bind:title="pageTitle" />

          <div class="d-flex flex-column-fluid">
            <div :class="{
              'container-fluid': contentFluid,
              container: !contentFluid
            }">
              <transition name="fade-in-up">
                <div>
                  <!-- begin:: only unread 3 latest notifications of type success - message - error  -->
                  <div v-for="notif in latestUnreadNotifications" :key="notif.id"
                    class="alert alert-custom alert-notice fade show mb-4" :class="alertBgClass(notif.type)"
                    role="alert">
                    <div class="alert-icon">
                      <i :class="alertIcon(notif.type)"></i>
                    </div>
                    <div class="alert-text">
                      <strong>{{ notif.title }}</strong>
                      <span class="d-block mt-1 font-size-sm" v-if="notif.message.length <= 100">
                        {{ notif.message }}
                      </span>
                      <span class="d-block mt-1 font-size-sm" v-else>
                        {{ notif.message.substring(0, 97) }}...
                        <router-link :to="{ name: 'notification-show', params: { id: notif.id } }"
                          class="text-primary font-weight-bold" @click.native.stop>
                           بیشتر . . .
                        </router-link>
                      </span>
                    </div>
                    <div class="alert-close">
                      <button type="button" class="close" data-dismiss="alert" aria-label="بستن"
                        @click="markAsSeenAndClose(notif.id)">
                        <span aria-hidden="true"><i class="ki ki-close"></i></span>
                      </button>
                    </div>
                  </div>
                  <!-- end:: check notifications -->

                  <!-- begin:: check profile compeleted -->
                  <div class="alert alert-custom alert-notice alert-light-danger fade show"
                    v-if="!isProfileCompeleted && !profileAlertClosed" role="alert">
                    <div class="alert-icon"><i class="flaticon-warning"></i></div>
                    <div class="alert-text">برای دسترسی به پنل ابتدا پروفایل خود را تکمیل نمایید</div>
                    <div class="alert-close">
                      <button type="button" class="close" data-dismiss="alert" aria-label="نزدیک"
                        @click="profileAlertClosed = true">
                        <span aria-hidden="true"><i class="ki ki-close"></i></span>
                      </button>
                    </div>
                  </div>
                  <!-- end:: check profile compeleted -->

                  <!-- begin:: check notifications -->
                  <!-- add codes -->
                  <!-- end:: check notifications -->

                  <router-view v-if="renderComponent" />
                </div>
              </transition>
            </div>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>

    <CompeleteProfileModal v-if="this.showMyModal" @close="showMyModal = false" />
    <modal v-if="showModal" />
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import CompeleteProfileModal from "@/view/content/CompeleteProfileModal.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";
import { VERIFY_USER } from "@/core/services/store/profile.module";
import { getToken } from "@/core/services/jwt.service";
import Modal from "../content/modals/Modal.vue";
import { FETCH_NOTIFICATION } from "@/core/services/store/notifications.module.js";
export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader,
    CompeleteProfileModal,
    Modal
  },
  data() {
    return {
      renderComponent: true,
      showMyModal: false,
      profileAlertClosed: false,
      dismissedNotificationIds: []
    };
  },
  watch: {
    isAuthenticated(val) {
      if (!val) {
        this.$router.push({ name: "otp" }).catch(() => { });
      }
    }
  },
  beforeMount() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "otp" });
    }

    this.$store
      .dispatch(VERIFY_USER)
      .then(() => {
        if (!this.isProfileCompeleted) {
          this.showMyModal = true;
        }

        if (
          this.currentUserCompany.id !== undefined &&
          this.currentUserCompany.id === 2
        ) {
          window.location.href = `https://tekye.mirol.ir/sign-in?token=${getToken()}`;
        }
      })
      .catch(e => void e);

    // Remove page loader after delay
    setTimeout(() => {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);

    this.eventHub.$on("re_render_page", this.reRenderPage);
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isProfileCompeleted",
      "currentUserPersonalInfo",
      "currentUserCompany",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "showModal"
    ]),
    ...mapGetters("notification", ["notifications", "unreadNotificationCount"]),
 
    latestUnreadNotifications() {
      return this.notifications
        .filter(n =>
          !n.seen_at &&
          ['success', 'message', 'error','warning'].includes(n.type) &&
          !this.dismissedNotificationIds.includes(n.id)
        )
        .slice(0, 2);
    },

    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    toolbarDisplay() {
      return false;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    }
  },
  methods: {
    async reRenderPage() {
      this.renderComponent = false;
      await this.$nextTick(() => {
        this.renderComponent = true;
      });
    },

    markAsSeenAndClose(id) {
      this.dismissedNotificationIds.push(id);
      this.$store.dispatch("notification/" + FETCH_NOTIFICATION, id);
    },

    alertBgClass(type) {
      const map = {
        success: "alert-light-success",
        message: "alert-light-primary",
        error: "alert-light-danger",
        warning: "alert-light-warning",
        info: "alert-light-info"
      };
      return map[type] || "alert-light-primary";
    },

    alertIcon(type) {
      const map = {
        success: "flaticon2-check-mark text-success",
        message: "flaticon2-chat-1 text-primary",
        error: "flaticon-warning text-danger",
        warning: "flaticon2-warning text-warning",
        info: "flaticon2-information text-info"
      };
      return map[type] || "flaticon2-bell-2 text-primary";
    }
  }
};

</script>
<style scoped>
.alert.alert-custom {
  padding: 0rem 2rem;
}
</style>